export { sessionReplayPlugin as plugin, sessionReplayPlugin, SessionReplayPlugin } from './session-replay';
export { AmplitudeSessionReplay, SessionReplayOptions } from '@amplitude/session-replay-browser';
